var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeasonLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Go to Season") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GWF-Series-Episodes-B-Edit-v.1.1",
    transform: "translate(-122.000000, -317.000000)",
    fill: "#111E3F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-16X16/Link/B/Dark",
    transform: "translate(97.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.001709,13 L3,13 L3,3 L5.99874878,3 L5.99874878,1 L3,1 C1.89,1 1,1.9 1,3 L1,13 C1,14.1 1.89,15 3,15 L13.001709,15 C14.101709,15 15.001709,14.1 15.001709,13 L15.001709,10 L13.001709,10 L13.001709,13 Z M8,1 L8,3 L11.59,3 L4.76,9.83 L6.17,11.24 L13,4.41 L13,8 L15,8 L15,1 L8,1 Z",
    id: "\\uD83D\\uDD39-Icon-Color"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasonLink);
export default __webpack_public_path__ + "static/media/SeasonLink.3fd61c05.svg";
export { ForwardRef as ReactComponent };